// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vertical .carousel-item-next.carousel-item-left,.vertical .carousel-item-prev.carousel-item-right{-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}.vertical .carousel-item-next,.vertical .active.carousel-item-right{-webkit-transform:translate3d(0, 100%, 0);transform:translate3d(0, 100% 0)}.vertical .carousel-item-prev,.vertical .active.carousel-item-left{-webkit-transform:translate3d(0, -100%, 0);transform:translate3d(0, -100%, 0)}", ""]);
// Exports
module.exports = exports;
